import * as wixStoreDataProvider from '../wixStoreDataProvider';
import { getWixStoreSections } from './wixStoreSections';

export const getAddPanelSection = function (editorAPI: AnyFixMe) {
  return getWixStoreSections(wixStoreDataProvider.isAppInstalled(editorAPI));
};
